import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/cases/listpage/retail/Template'

const Retail: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'事例 実績 小売 流通 物流 卸売'}
        image={'https://www.i3design.jp/ogp_logo.png'}
        url={'https://www.i3design.jp/cases/retail/'}
        title="小売/流通/卸 | 事例 | i3DESIGN アイスリーデザイン"
        description="小売/流通/卸のケーススタディを紹介します｜クラウドネイティブ、AI駆動開発、デザインシステムに精通した様々な支援実績がございます。UX/UIデザイン、モダンスタック技術、CI/CD、DevOps環境、AIエージェントをフル活用した開発スタイルで顧客のデジタルシフトを支援します。"
      />
      <Template pageId={1} />
    </>
  )
}

export default Retail
